module.exports = __webpack_public_path__ + "img/brand5-Photo.efa6d94f.png";